import { Achievements } from '@components/_ui/Achievements'
import { AnimatedPanel } from '@components/_ui/AnimatedPanel'
import { Portal } from '@components/Portal'
import { useWatch } from 'react-hook-form'

import s from './Header.module.scss'
import type { HeaderProps } from './Header.props'

export function Header(props: HeaderProps) {
  const сleaningType = useWatch({ name: 'requested_cleaning_type' })

  const data = props.data?.[сleaningType === 'airbnb' ? 'airbnb' : 'other']

  return (
    <div className={s.header}>
      <h1
        className={s.title}
        dangerouslySetInnerHTML={{ __html: data.title }}
      />

      <Achievements achievements={data?.achievements} />

      <Portal id="animated-root">
        <AnimatedPanel text={data?.cta?.title || ''} />
      </Portal>
    </div>
  )
}
